export default "__VITE_ASSET__Bu7n15dJ__"